import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersist from 'vuex-persist'

import User from '@/model/User'

Vue.use(Vuex)

const storeKey = 'pcnweb'
const usedStorage = window.localStorage
const storeDefaults = {
    currentUser: null,
    userSettings: {},
    xAuthToken: null,
    availableStates: [],
    cookieNoticeAccepted: false
}

// Initialize persistence
const vuexPersist = new VuexPersist({
    key: storeKey,
    saveState: (key, state) => {
        const values = {
            userSettings: state.userSettings,
            currentUser: state.currentUser,
            xAuthToken: state.xAuthToken,
            cookieNoticeAccepted: state.cookieNoticeAccepted
        }
        usedStorage.setItem(key, JSON.stringify(values))
    },
    restoreState: (key) => {
        var stored = JSON.parse(usedStorage.getItem(key))

        try {
            stored.currentUser = User.fromObject(stored.currentUser)
        } catch (err) {
            stored = storeDefaults
            usedStorage.setItem(key, JSON.stringify(stored))
        }

        return stored
    }
})

// Initialize store
const store = new Vuex.Store({
    plugins: [vuexPersist.plugin],
    
    state: storeDefaults,

    mutations: {
        userSettings (state, data) {
            state.userSettings = data
        },

        setCurrentUser (state, data) {
            state.currentUser = data
        },

        xAuthToken (state, token) {
            state.xAuthToken = token
        },

        availableStates (state, list) {
            if (list instanceof Array && list.length > 0) {
                state.availableStates = list
            }
        },

        cookieNoticeAccepted (state, accepted) {
            if (typeof accepted !== 'boolean') {
                return
            }

            state.cookieNoticeAccepted = accepted
        }
    }
})

export default store
